module.exports = __webpack_public_path__ + "597d0f211919dfbf30aed462cd00e987.webp";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/LynksExport/assets/Sec-2/icon_2.webp
// module id = ./app/containers/StaticPage/LynksExport/assets/Sec-2/icon_2.webp
// module chunks = 40